var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"textOverflow",staticClass:"text-overflow",style:(_vm.boxStyle)},[_c('span',{ref:"overEllipsis"},[_vm._v(_vm._s(_vm.realText))]),(_vm.showSlotNode)?_c('span',{ref:"slotRef",staticClass:"slot-box"},[_vm._t("default",null,{"clickToggle":_vm.toggle,"expanded":_vm.expanded})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }